import { computed, ref, watch, type ComputedRef } from 'vue'
import {
  hasLightingEditableField,
  LIGHTING_EDITABLE_FIELD,
  LIGHTING_EFFECT_KIND,
  type LightingEffectDefinition,
} from '@rapoo/device-sdk'

type SelectedKey = { index: number }

export function useKeySelection(
  currentEffectInfo: ComputedRef<LightingEffectDefinition | undefined>,
) {
  const selectedKeys = ref<SelectedKey[]>([])

  const currentCustomStaticMode = computed(() => {
    if (currentEffectInfo.value?.kind !== LIGHTING_EFFECT_KIND.Static) return null
    if (!currentEffectInfo.value?.isCustom) return null
    return currentEffectInfo.value
  })

  const canEditKeySelection = computed(() => {
    return Boolean(
      currentCustomStaticMode.value &&
      hasLightingEditableField(currentCustomStaticMode.value, LIGHTING_EDITABLE_FIELD.Color) &&
      !hasLightingEditableField(currentCustomStaticMode.value, LIGHTING_EDITABLE_FIELD.Gradient),
    )
  })

  const handleSelectedKeysChange = (keys: SelectedKey[]) => {
    selectedKeys.value = keys
  }

  const clearSelectedKeys = () => {
    selectedKeys.value = []
  }

  // 退出可编辑的自定义静态模式时清空已选键位
  watch(
    canEditKeySelection,
    (canEdit) => {
      if (!canEdit) clearSelectedKeys()
    },
    { immediate: true },
  )

  return {
    selectedKeys,
    canEditKeySelection,
    handleSelectedKeysChange,
    clearSelectedKeys,
  }
}
